import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import './Dropdown.css'

const Dropdown = (props) => {
  const [openSubMenus, setOpenSubMenus] = useState({});

  const toggleSubMenu = (category) => {
    setOpenSubMenus((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <div className="text-with-choices">
      <p className="clickable-text" onClick={props.onToggle}>
        {props.name}
        {props.icon && <FontAwesomeIcon className="sideIcon" icon={props.icon} />}
      </p>

      {props.isOpen && (
        <div className={`choices-wrapper ${props.isOpen ? "open" : ""}`}>
  <div className="choices-inner">
    {props.choices.map((choice, index) => (
      <div key={index} className="clickdiv">
        {choice.category ? (
          <div>
            <p className="clickable-submenu" onClick={() => toggleSubMenu(choice.category)}>
              {choice.category}
            </p>
            {openSubMenus[choice.category] && (
              <div className="sub-choices">
                {choice.subChoices.map((subChoice, subIndex) => (
                  <Link key={subIndex} className="sidebar-subelement" to={subChoice.route}>
                    {subChoice.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        ) : (
          <Link className="sidebar-subelement" to={choice.route}>
            {choice.label}
          </Link>
        )}
      </div>
    ))}
  </div>
</div>

      )}
    </div>
  );
};

export default Dropdown;
